const SELECTORS = {
  toast: ".js-printer-queue-toast",
  text: ".js-printer-queue-toast-text",
  close: ".js-printer-queue-toast-close"
};
const AUTO_CLOSE_MS = 3000;
const autoCloseTimers = new WeakMap();

const getToastTextEl = $toastEl => ($toastEl ? $toastEl.querySelector(SELECTORS.text) : null);

const setToastText = ($toastEl, text) => {
  const $textEl = getToastTextEl($toastEl);
  if ($textEl) {
    $textEl.textContent = text;
  } else {
    $toastEl.textContent = text;
  }
};

const clearAutoCloseTimer = $toastEl => {
  const timerId = autoCloseTimers.get($toastEl);
  if (timerId) {
    window.clearTimeout(timerId);
    autoCloseTimers.delete($toastEl);
  }
};

const clearPrinterQueueToast = $toastEl => {
  if (!$toastEl) return;
  setToastText($toastEl, "");
  $toastEl.classList.add("hidden");
  $toastEl.setAttribute("aria-hidden", "true");
  clearAutoCloseTimer($toastEl);
};

const showPrinterQueueToast = ($toastEl, message) => {
  if (!$toastEl) return;
  setToastText($toastEl, message);
  $toastEl.classList.remove("hidden");
  $toastEl.removeAttribute("aria-hidden");
  clearAutoCloseTimer($toastEl);
  const timerId = window.setTimeout(() => clearPrinterQueueToast($toastEl), AUTO_CLOSE_MS);
  autoCloseTimers.set($toastEl, timerId);
};

const initPrinterQueueToast = $container => {
  if (!$container) return;
  const $toastEl = $container.querySelector(SELECTORS.toast);
  if (!$toastEl) return;
  const $closeButton = $toastEl.querySelector(SELECTORS.close);
  if ($closeButton) {
    $closeButton.addEventListener("click", () => clearPrinterQueueToast($toastEl));
  }
};

export { showPrinterQueueToast, clearPrinterQueueToast, initPrinterQueueToast };
